import { Menu, UserCircle, X } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FamilyContext } from '../../Context/FamilyHeadContext'
import hebrewStyles from '../../data/hebrewFamilyHeadStyles.json'    // שינוי שם הייבוא
import englishStyles from '../../data/englishFamilyHeadStyles.json'  // הוספת ייבוא חדש
import UnifiedSearch from '../../pages/Search/UnifiedSearch'
import { API_URL } from '../../services/apiService'
import LanguageSelector from '../language/LanguageSelector'
import DesktopFamilyTreeDropdown from './DesktopFamilyTreeDropdown'
import HeaderTitle from './HeaderTitle'
import MobileFamilyTreeDropdown from './MobileFamilyTreeDropdown'
import MobileHeader from './MobileHeader'
import NavLink from './NavLink'
import {useTranslation} from "react-i18next";

const Header = () => {
  const navigate = useNavigate()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const {pathPrefix, headerStyle} = useContext(FamilyContext)
  const { currentFamilyHead, isAuthenticated } = useContext(FamilyContext)
    const {t, i18n} = useTranslation();

    // בחירת הסגנון לפי השפה
    const styles = i18n.language === 'en' ? englishStyles : hebrewStyles;
  const [activeStyle, setActiveStyle] = useState(
      styles[currentFamilyHead.nickname]
  )
  const FAMILY_HEADS_WITH_ESSAYS = ['malin', 'bazach']

    // עדכון הסגנון כשהשפה משתנה
    useEffect(() => {
        setActiveStyle(styles[currentFamilyHead.nickname])
    }, [currentFamilyHead, i18n.language, styles])

  const navLinks = [
    {
      type: 'component',
      component: ({onMobileMenuClose}) => (
          <div className="flex items-center gap-6">
            <LanguageSelector onSelect={onMobileMenuClose}/>
            {isAuthenticated && (
                <>
                  <div className="hidden nav-break:block">
                    <DesktopFamilyTreeDropdown/>
                  </div>
                  <div className="block nav-break:hidden">
                    <MobileFamilyTreeDropdown onMobileMenuClose={onMobileMenuClose}/>
                  </div>
                  <Link
                      to={`${pathPrefix}admin`}
                      onClick={onMobileMenuClose}
                  >
                    ניהול
                  </Link>
                </>
            )}
          </div>
      ),
    },
    { type: 'link', to: `${pathPrefix}`, text: t('navbar.home') },
    ...(FAMILY_HEADS_WITH_ESSAYS.includes(currentFamilyHead.nickname)
      ? [
          {
            type: 'link',
            to: `${pathPrefix}essays`,
            text: t('navbar.essays'),
          },
        ]
      : []),
    {
      type: 'link',
      to: `${pathPrefix}family-index`,
      text: t('navbar.descendants'),
    },
    {
      type: 'link',
      to: `${pathPrefix}forum`,
      text: t('navbar.familyForum'),
    },
    { type: 'link', to: `${pathPrefix}about`, text: t('navbar.contact') },
  ]

  useEffect(() => {
      setActiveStyle(styles[currentFamilyHead.nickname])
  }, [currentFamilyHead])

  const dynamicStyles = {
    mainHeader: {
      ...headerStyle || {
        background: Array.isArray(activeStyle.backgroundColor)
            ? `linear-gradient(to bottom, ${activeStyle.backgroundColor[0]}, ${activeStyle.backgroundColor[1]})`
            : `linear-gradient(to bottom, ${activeStyle.backgroundColor}, ${activeStyle.backgroundColor}cc)`,
      }
    },
    stickyHeader: {
      background: headerStyle?.style?.background || (Array.isArray(activeStyle.backgroundColor)
          ? `linear-gradient(to bottom, ${activeStyle.backgroundColor[0]}, ${activeStyle.backgroundColor[1]})`
          : `linear-gradient(to bottom, ${activeStyle.backgroundColor}, ${activeStyle.backgroundColor}cc)`)
    },
    mobileMenu: {
      background: Array.isArray(activeStyle.backgroundColor)
        ? `linear-gradient(to bottom, ${activeStyle.backgroundColor[0]}, ${activeStyle.backgroundColor[1]})`
        : `linear-gradient(to bottom, ${activeStyle.backgroundColor}, ${activeStyle.backgroundColor}cc)`,
    },
  }

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen)
  const closeMobileMenu = () => setIsMobileMenuOpen(false)

  const commonClasses = {
    menuButton:
      'p-2 hover:bg-opacity-20 hover:bg-white rounded-full transition-colors',
    logo: ' cursor-pointer rounded-xl hover:ring-opacity-50 transition-all duration-300 transform hover:scale-105',
  }

  return (
      <header className="relative">
        {/* Sticky Header */}
        <div
            style={dynamicStyles.stickyHeader}
            className={`
          fixed top-0 right-0 left-0 z-50 backdrop-blur-sm
          transform transition-all duration-300
          ${isScrolled ? 'translate-y-0 shadow-lg' : '-translate-y-full'}
        `}
        >
          {/* שאר התוכן נשאר ללא שינוי */}
          <div className="max-w-8xl mx-auto px-2">
            <div className="h-16 flex items-center justify-between gap-2">
              <button
                  onClick={toggleMobileMenu}
                  className={`nav-break:hidden ${commonClasses.menuButton}`}
              >
                {isMobileMenuOpen ? (
                    <X className="w-10 h-10 text-[#8B5E3C]"/>
                ) : (
                    <Menu className="w-10 h-10 text-[#8B5E3C]"/>
                )}
              </button>
              <nav className="hidden nav-break:flex items-center space-x-6">
                {navLinks.map((item, index) => (
                    <NavLink key={index} item={item}/>
                ))}
              </nav>
              <div className="w-full max-w-xs">
                <UnifiedSearch variant="expandable"/>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div
            style={dynamicStyles.mainHeader}
            className={`
        sticky top-0 right-0 left-0 z-40 backdrop-blur-sm
        transition-opacity duration-300
        nav-break:min-h-0 min-h-[100px]
        ${isScrolled ? 'opacity-0 pointer-events-none' : 'opacity-100'}
    `}
        >
          <div className="max-w-7xl mx-auto px-4">
            <MobileHeader
                toggleMobileMenu={toggleMobileMenu}
                activeStyle={activeStyle}
                commonClasses={commonClasses}
                navigate={navigate}
                isMobileMenuOpen={isMobileMenuOpen}
                closeMobileMenu={closeMobileMenu}
                navLinks={navLinks}
                dynamicStyles={dynamicStyles}
            />

            {/* Desktop Layout */}
            <div className="hidden nav-break:block py-4">
              <div className="flex justify-center items-center">
                <div className="flex items-center gap-8">
                  {/* הצגת/הסתרת לוגו */}
                  {!headerStyle?.settings?.hideLogo && (
                      <Link
                          to={`${pathPrefix}`}
                          className="cursor-pointer hover:text-[#698fb8] transition-colors duration-300"
                      >
                        {currentFamilyHead.images?.[0]?.key ? (
                            <img
                                crossOrigin="use-credentials"
                                src={`${API_URL}/image/download/${encodeURIComponent(
                                    currentFamilyHead.images[0].key,
                                )}`}
                                alt={currentFamilyHead.name}
                                className={`w-28 h-28 ${commonClasses.logo}`}
                                onClick={() => navigate('/')}
                            />
                        ) : (
                            <UserCircle className="w-28 h-28"/>
                        )}
                      </Link>
                  )}

                  <div>
                    {headerStyle?.settings?.customTitle ? (
                        <h3 className="text-subtitle-xl sm:text-subtitle-md lg:text-2xl text-[#5C4033] font-heebo text-center">
                          {headerStyle.settings.customTitle}
                        </h3>
                    ) : (
                        <>
                          <h3 className="text-subtitle-xl sm:text-subtitle-md lg:text-2xl text-[#5C4033] font-heebo text-center">
                            {activeStyle.headerText}
                          </h3>
                          <HeaderTitle title={activeStyle.title}/>
                        </>
                    )}
                  </div>
                </div>
              </div>

              {/* Desktop Search */}
              <div className="absolute top-4 left-4">
                <div className="flex items-center gap-4">
                  <div className="w-64">
                    <UnifiedSearch variant="expandable"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation - Desktop */}
          <nav
              className={`hidden nav-break:block shadow-md ${activeStyle.customClass}`}
          >
            <div className="max-w-7xl mx-auto">
              <div className="flex justify-center items-center py-3 space-x-8">
                {navLinks.map((item, index) => (
                    <NavLink key={index} item={item}/>
                ))}
              </div>
            </div>
          </nav>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
            <div
                style={dynamicStyles.mobileMenu}
                className="nav-break:hidden fixed inset-0 backdrop-blur-md z-40"
            >
              <button
                  onClick={toggleMobileMenu}
                  className={`absolute top-4 right-4 ${commonClasses.menuButton}`}
              >
                <X className="w-8 h-8 text-[#8B5E3C]"/>
              </button>
              <div className="h-full flex flex-col items-center justify-center gap-8 p-6">
                {navLinks.map((item, index) => (
                    <NavLink key={index} item={item} onNavigate={closeMobileMenu}/>
                ))}
              </div>
            </div>
        )}
      </header>
  )
}

export default Header
